import styled from '@emotion/styled';
import { AdditionalInfoSeverity } from './AdditionalInfo.types';

const Wrapper = styled.div<{
  hasCustomIcon: boolean;
  severity: AdditionalInfoSeverity;
}>`
  display: flex;
  align-items: ${({ hasCustomIcon }) => (hasCustomIcon ? 'center' : 'end')};
  gap: ${({ theme, hasCustomIcon }) =>
    hasCustomIcon ? theme.spacing[20] : theme.spacing[30]};
  padding: ${({ theme, hasCustomIcon }) =>
    hasCustomIcon ? theme.spacing[40] : `0 0.875rem 0 ${theme.spacing[20]}`};
  border: ${({ theme, severity }) =>
    `2px solid ${severity === AdditionalInfoSeverity.INFO ? 'currentcolor' : theme.colors.brand.green100}`};
  border-radius: ${({ theme }) => theme.radius.md};
  color: ${({ theme, severity }) =>
    severity === AdditionalInfoSeverity.INFO
      ? theme.colors.accent.blue100
      : theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  fill: ${({ theme, severity }) =>
    severity === AdditionalInfoSeverity.INFO
      ? 'currentcolor'
      : theme.colors.brand.green100};
  font-weight: 600;
  font-size: ${({ theme, hasCustomIcon }) =>
    hasCustomIcon ? theme.fontSize.xs.size : theme.fontSize.sm.size};
  line-height: 1.5;
  overflow: hidden;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`;

const Content = styled.div<{ hasCustomIcon: boolean }>`
  margin: ${({ theme, hasCustomIcon }) =>
    hasCustomIcon ? '0' : `${theme.spacing[40]} 0`};
  align-self: center;
`;

const InfoIcon = styled.svg`
  margin: 4px 0 -4px;
  width: 100px;
  height: auto;
`;

const CircleWithSeverityColor = styled.circle<{
  severity: AdditionalInfoSeverity;
}>`
  fill: ${({ theme, severity }) =>
    severity === AdditionalInfoSeverity.INFO
      ? theme.colors.accent.blue20
      : theme.colors.brand.green20};
`;

const PathWithSeverityColor = styled.path<{
  severity: AdditionalInfoSeverity;
}>`
  fill: ${({ theme, severity }) =>
    severity === AdditionalInfoSeverity.INFO
      ? theme.colors.accent.blue100
      : theme.colors.brand.green120};
`;

export {
  Wrapper,
  IconWrapper,
  Content,
  InfoIcon,
  CircleWithSeverityColor,
  PathWithSeverityColor,
};
